import { Flex } from '@chakra-ui/react';
import _ from 'lodash';
import { KText } from '@/ui-library/components';
import { CSSProperties } from 'react';

type TabItem = {
  label: string;
  id: string;
  selected: boolean;
  onClick?: () => void;
  isSelected: boolean;
  count: number;
};

const TabItemComponent = ({
  item,
  selectedItem,
  onMClick,
  enableCount = false,
}: {
  item: TabItem;
  selectedItem: TabItem;
  onMClick: (_item: TabItem) => void;
  enableCount?: boolean;
}) => {
  const isSelected = item.id === selectedItem.id;

  return (
    <Flex
      className={`${isSelected ? 'active' : ''}`}
      padding="13px 0"
      marginRight="30px"
      cursor="pointer"
      onClick={() => {
        onMClick(item);
      }}
      position="relative"
    >
      <Flex alignItems="center" gap="5px">
        <Flex>
          <KText
            className="label"
            size="sm-medium"
            color={isSelected ? 'primary-500' : 'secondary-700'}
            fontWeight={isSelected ? '650' : '550'}
          >
            {item.label}
          </KText>
        </Flex>
        {enableCount && (
          <Flex
            ml="5px"
            bg={isSelected ? 'primary-100' : 'secondary-100'}
            borderRadius="6px"
            p="2px 6px"
          >
            <KText
              size="sm-medium"
              color={isSelected ? 'primary-600' : 'secondary-700'}
              minW="10px"
              textAlign="center"
            >
              {item.count || 0}
            </KText>
          </Flex>
        )}
      </Flex>
      {isSelected && (
        <Flex
          position={'absolute'}
          bottom={0}
          height={'3px'}
          width={'100%'}
          bg="primary-500"
        />
      )}
    </Flex>
  );
};

export const TabsList = ({
  items,
  selectedItem,
  onTabSelection,
  containerStyles,
  enableCount = false,
}: {
  items: TabItem[];
  selectedItem: TabItem;
  onTabSelection: (_item: TabItem) => void;
  containerStyles?: CSSProperties;
  enableCount?: boolean;
}) => {
  const itemsUpdated = _.cloneDeep(items) || [];

  return (
    <Flex
      borderBottom="1px solid"
      borderColor="secondary-100"
      style={containerStyles}
    >
      {itemsUpdated?.map((item, index) => (
        <TabItemComponent
          key={index}
          item={item}
          selectedItem={selectedItem}
          onMClick={() => onTabSelection(item)}
          enableCount={enableCount}
        />
      ))}
    </Flex>
  );
};
